import React from 'react'
import './Graph.css'

function PersonalityReport(props) {

    const {resultData} = props
    console.log(resultData[7])

    let careers = resultData[0]
    let communicationStyle = resultData[1]
    let growthPotential = resultData[2]
    let valuesAndMotivations = resultData[6]
    let workPlaceHabits = resultData[7]

  return (
    <div className='result-container'>

        <u><h3 className='result'>RESULT</h3></u>

        <div style={{textAlign:'left'}}>
            {/* <div>
                <div className='report-points'>Carees to Avoid</div>
                <ul className='text'>
                    {
                        careers.map(item => {
                            return (
                                <p>{item}</p>
                            )
                        })
                    }
                </ul>
            </div> */}

            <div className='report-points-container'>
                <div className='report-points'>Communication Style</div>
                <div className='text'>
                    {communicationStyle}
                </div>
            </div>


            <div className='report-points-container'>
                <div className='report-points'>Values and Motivations</div>
                <div className='text'>
                    {valuesAndMotivations}
                </div>
            </div>

            <div className='report-points-container'>
                <div className='report-points'>Work Place Habits</div>
                <div className='text'>
                    {workPlaceHabits}
                </div>
            </div>
        </div>

    </div>
  )
}

export default PersonalityReport